export default __webpack_public_path__ + "static/media/08_bose_hellberg_lesmes.d11d6035.gif";